import React from "react";
import {Helmet} from "react-helmet";
import {HelmetProvider} from "react-helmet-async";
import AdminLayout from "../components/AdminLayout";
import AdminOrdersShared from "../components/AdminOrdersShared";

const AdminViewOrders: React.FC = () => {
    return (
        <AdminLayout>
            <HelmetProvider>
                <Helmet title="Админка"/>
            </HelmetProvider>

            <div className="page_content admin-orders-page">
                <AdminOrdersShared mode="view"/>
            </div>
        </AdminLayout>
    );
};

export default AdminViewOrders;
